import { types, flow, getRoot, applySnapshot } from "mobx-state-tree";
import { db } from "../firebase.js";
import { actions } from "./_common.js";
import { values } from "mobx";
import { removeInternalPropsAndFuncs } from "../helpers";
import FirestoreDate from "./FirestoreDate";

const groupsRef = db.collection("groups");

export const Group = types.compose(
  types
    .model({
      _key: types.maybeNull(types.string),
      name: types.maybeNull(types.string),
      createdBy: types.maybeNull(types.string),
      educationLevel: types.maybeNull(types.string),
      brugFiguur: types.maybeNull(types.boolean),
      createdOn: FirestoreDate,
      createdByEmail: types.maybeNull(types.string),
      respondentCount: types.frozen({})
    })
    .actions(self => ({
      fsSave: flow(function* () {
        let keyNew = self._key === "new" || !self._key;
        let doc = !keyNew ? groupsRef.doc(self._key) : groupsRef.doc();
        let group = removeInternalPropsAndFuncs(self.toJSON());
        yield !keyNew ? doc.update(group) : doc.set(group);
        return doc;
      }),
      delete: flow(function* () {
        const { $alert } = getRoot(self);
        $alert.add("loading");
        yield groupsRef.doc(self._key).delete();
        $alert.delete("loading");
      })
    }))
    .views(self => ({
      get responses() {
        return values(getRoot(self).$respondent.list).filter(
          respondent => respondent.groupKey === self._key
        );
      },
      get responsesLength() {
        return self.responses.length;
      },
      get respondentCountForSelectedSurvey() {
        const { $survey } = getRoot(self);
        if (!$survey.selected) return null;
        return self.respondentCount[$survey.selected._key] || 0;
      },
      get totalRespondentCount() {
        let total = 0;
        Object.keys(self.respondentCount).forEach(key => {
          total += self.respondentCount[key];
        });
        return total;
      }
    })),
  actions
);

export const GroupStore = types.compose(
  types
    .model({
      list: types.optional(types.map(Group), {}),
      status: types.optional(types.string, "pending"),
      selected: types.maybeNull(Group),
      filterSearch: types.optional(types.string, ""),
      confirmDelete: types.optional(types.boolean, false)
    })
    .views(self => ({
      get activeGroupKeys() {
        let keys = [];
        const { $user, $router, $group } = getRoot(self);
        if (
          $user.sessionUser.isAnonymous &&
          ($router.getURLParameterByName("group") || localStorage.getItem("barometer-group"))
        ) {
          keys.push(
            $router.getURLParameterByName("group") || localStorage.getItem("barometer-group")
          );
        } else {
          if ($group.selected) {
            if (!$user.sessionUser.isVerifiedCreator) {
              keys = $user.sessionUser.groups;
            } else {
              keys.push($group.selected._key);
            }
          }
        }
        return keys;
      }
    }))
    .volatile(self => ({
      unsubscribe: types.function
    }))
    .actions(self => ({
      load: flow(function* (key) {
        console.log("> load group", key);
        const { $alert } = getRoot(self);
        $alert.add("loading");
        try {
          let snapshot = false;
          if (key) {
            snapshot = yield groupsRef.doc(key).get();
            self.setToList(snapshot.id, snapshot.data());
            self.change("selected", { _key: snapshot.id, ...snapshot.data() });
          } else {
            self.change("list", {});
            self.unsubscribe = groupsRef.onSnapshot(snapshot => {
              let list = {};
              snapshot.forEach(doc => {
                list[doc.id] = doc.data();
                list[doc.id]._key = doc.id;
              });
              applySnapshot(self.list, list);
            });
          }
          self.setProp("status", "done");
          $alert.delete("loading");
        } catch (error) {
          console.log("error", error);
        }
      }),
      setSelected(group) {
        //const { $user } = getRoot(self);
        self.selected = group;
        //$user.loadMeta({ groupKey: group });
      }
    })),
  actions
);
